import styled from "@emotion/styled";
import { TextInput } from "../../../textinput";

export const DatePickerTextInputStyled = styled(TextInput)`
    z-index: 0;
    position: relative;

    &.compact-dp-input {
        width: 138px;
    }

    &:not(.compact-dp-input) {
        min-width: 138px;
    }
`;
